import React, { Component } from "react";
import classnames from "classnames";
import Paper from "@material-ui/core/Paper";
import { withTranslation, Trans } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import FormControl from "@material-ui/core/FormControl";
import imgUrl from "../../assets/images/imageUrl.js";
import Loader from "../loaders/loader";
import { connect } from "react-redux";
import { useHistory, withRouter, Route, Redirect, Switch, Link } from "react-router-dom";
import { withStyles, makeStyles, useTheme, withTheme } from "@material-ui/core/styles";
import { signInAnonymously } from "../../helpers/auth";
import { auth } from "../../service/firebase";
import { db, storageRef } from "../../service/firebase";
import ApiServices from "../../api/api";
import TextField from "@material-ui/core/TextField";
import Services from "../../api/api";
import swal from "sweetalert";
import OffileDb from '../../config/pouchDB';
import { gaLogEvent } from "../../helpers/analytics";


class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      userDetails: [],
      name: '',
      oldpassword: '',
      newpassword:'',
      renewpassword:'',
      pin: '',
      passwordVisibility1: false,
      passwordVisibility2: false,
      passwordVisibility3: false,
      
    };
  
    this.handleNewPass=this.handleNewPass.bind(this);
    this.handleReNewPass=this.handleReNewPass.bind(this);
    this.handleOldPass=this.handleOldPass.bind(this);
    this.getUserDeatils = this.getUserDeatils.bind(this);
    this.toggleVisibility = this.toggleVisibility.bind(this);
  }

  componentDidMount() {
    gaLogEvent("Settings Reset Password", '', '');

    OffileDb.setDatabase()
  }


  handleOldPass(event) {
    // console.log(event)
    this.setState({
      oldpassword: event.target.value,
    });
  }

  handleNewPass(event) {
    // console.log(event)
    this.setState({
      newpassword: event.target.value,
    });
  }

  handleReNewPass(event) {
    // console.log(event)
    this.setState({
      renewpassword: event.target.value,
    });
  }

  handleSubmit = (event) => {
    var self = this;
    event.preventDefault();
    const { t } = this.props;
    this.setState({ isLoading: true });

    var param = {
      "communityId": this.props.communityuid,
      "newPassword": this.state.newpassword,
      "oldPassword": this.state.oldpassword,
      "userName": localStorage.getItem('loggedinuser')
    };

    console.log("login param:", param)

    if (this.state.newpassword==this.state.renewpassword) {
      Services.ResetPassword(param).then((res) => {
        try {
          if (res.data.status == 200) {
            // OffileDb.deleteDatabse();
            setTimeout(function () {
              // localStorage.setItem('tempuserobj', localStorage.getItem('obj'))
              // localStorage.setItem('adminobj', JSON.stringify({
              //   roleId: res.data.data.roleId,
              //   roleType: res.data.data.masterRoleType.roleType,
              //   userId: res.data.data.userId,
              //   userType: res.data.data.userType,
              //   communityId: res.data.data.communityId
              // }))
              // localStorage.setItem('obj', JSON.stringify({
              //   roleId: res.data.data.roleId,
              //   roleType: res.data.data.masterRoleType.roleType,
              //   userId: res.data.data.userId,
              //   userType: res.data.data.userType,
              //   communityId: res.data.data.communityId
              // }))
              // self.getUserDeatils(res.data.data.userId)
              // self.getUserDeatils(JSON.parse(localStorage.getItem('obj')).userId)
              localStorage.setItem('loggedinpass', self.state.newpassword)
              self.props.history.push("/layout/userlogin");
            }, 500);
          }
        } catch (err) {
          console.log("Error::", err);
        }
      });
    } else {
      swal({
        title: t("Passwords mismatch. Please enter correct passwords"),
        icon: "warning",
        button: t("Ok"),
      })
    }

  };

  getUserDeatils(userId) {
    var param = {
      "communityId": this.props.communityuid,
      "userId": userId
    }
    ApiServices.getUserProfile(param).then((res) => {
      if (res.status == 200) {
        if(res.data.data.profile && res.data.data.profile.nickName){
          signInAnonymously().then((s) => {
            auth().onAuthStateChanged((user) => {
              if (user) {
                user.updateProfile({
                  displayName: res.data.data.profile.nickName,
                }).then(function (s) {
                    console.log("updateProfile res>>", s);
                  }).catch(function (error) {
                    console.log("updateProfile error>>", error);
                  });
              }
            });
          }).catch((err) => console.log("err>>>", err));
        }
      }
      this.props.history.push("/layout");
    });
  }

  toggleVisibility(number) {
    if(number==1){
      this.setState({
        passwordVisibility1: !this.state.passwordVisibility1
      })
    }else if(number==2){
      this.setState({
        passwordVisibility2: !this.state.passwordVisibility2
      })
    }
    else{
      this.setState({
        passwordVisibility3: !this.state.passwordVisibility3
      })
    }
  }

  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    return (
      <div className="gk-page getknowledgeable_page">

        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div className="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" className="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>

            </div>
          )
        }

        <form
          id="chat-profile"
          onSubmit={this.handleSubmit}
        >
          <Grid container spacing={3} className="gridcontainer">
          <Grid item xs={12} className="profileformholder bgcolorOfCard">
              <p className="chatusername">{t("Enter old password")}</p>
              <div style={{'display':'flex'}}>
              <TextField
                id="standard-helperText"
                type="password"
                type={this.state.passwordVisibility1 ? "text" : "password"}
                onChange={this.handleOldPass}
              />
              <Button className="toggle-pw-visibility1"
                    id="toggle-pw-visibility"
                    onClick={()=>this.toggleVisibility(1)}
                    style={this.state.passwordVisibility1 ? {} : { textDecoration: "line-through" }}
                  >
                    👁
              </Button>
              </div>
            </Grid>
            <Grid item xs={12} className="profileformholder bgcolorOfCard">
              <p className="chatusername">{t("Enter a new password")}</p>
              <div style={{'display':'flex'}}>
              <TextField
                id="standard-helperText"
                type="password"
                type={this.state.passwordVisibility2 ? "text" : "password"}
                onChange={this.handleNewPass}
              />
              <Button className="toggle-pw-visibility2"
                    id="toggle-pw-visibility"
                    onClick={()=>this.toggleVisibility(2)}
                    style={this.state.passwordVisibility2 ? {} : { textDecoration: "line-through" }}
                  >
                    👁
              </Button>
              </div>
            </Grid>
            <Grid item xs={12} className="profileformholder bgcolorOfCard">
              <p className="chatusername">{t("Re enter new password")}</p>
              <div style={{'display':'flex'}}>
              <TextField
                id="standard-helperText"
                type="password"
                // label={t("Re enter new pin")}
                type={this.state.passwordVisibility3 ? "text" : "password"}
                onChange={this.handleReNewPass}
              />
              <Button className="toggle-pw-visibility3"
                    id="toggle-pw-visibility"
                    onClick={()=>this.toggleVisibility(3)}
                    style={this.state.passwordVisibility3 ? {} : { textDecoration: "line-through" }}
                  >
                    👁
              </Button>
              </div>
            </Grid>
            <Grid item xs={12} className="profileformholder">
              <div className="text-center">
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  disableElevation
                  className="profilesubmitbtn"
                >
                  {t('Set Password')}
                </Button>
              </div>
            </Grid>
          </Grid>
        </form>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
  };
};

const transResetPass = withTranslation()(ResetPassword);
const themeResetPass = withTheme(transResetPass);
const routeResetPass = withRouter(themeResetPass);
export default connect(mapStateToProps, {})(routeResetPass);
